import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome, YesNoColumn } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function MarketPlatformScreen() {
    const { t } = useTranslation();
    const params = useParams();
    const header = t("Платформы");
    return (
        <DefaultLayout>{params.id ? <Edit id={params.id} header={header} /> : <List header={header} />}</DefaultLayout>
    );
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:market:platform:list"));

    if (!apiData) return;

    const headerTools = (
        <Link to={url_reverse("market:platform:edit", { platform_id: "add" })} className="btn btn-sm btn-dark">
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("URL активации")}</th>
                        <th>{t("Инструкция")}</th>
                        <th>{t("Логотип (страница игры)")}</th>
                        <th>{t("Логотип (список игр)")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o, i) => {
                        return (
                            <tr key={`object_list${i}`}>
                                <td>
                                    <Link to={url_reverse("market:platform:edit", { platform_id: o.id })}>
                                        {o.name}
                                    </Link>
                                </td>
                                <td>
                                    <YesNoColumn attr={o.url} />
                                </td>
                                <td>
                                    <YesNoColumn attr={o.instruction} />
                                </td>
                                <td>
                                    <YesNoColumn attr={o.logo} />
                                </td>
                                <td>
                                    <YesNoColumn attr={o.logo_list} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { apiData } = useAppApi(url_reverse("api:market:platform:edit", { platform_id: id }));

    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("market:platform:list")} />
        </CommonCard>
    );
}
